import { render } from "./MyHeaderElement.vue?vue&type=template&id=47c3a97a"
import script from "./MyHeaderElement.vue?vue&type=script&lang=js"
export * from "./MyHeaderElement.vue?vue&type=script&lang=js"

import "./MyHeaderElement.vue?vue&type=style&index=0&id=47c3a97a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__